import { MAX_CHUNKED_UPLOAD_FILE_SIZE } from "@repo/api/src/schemas/upload-limits";

export function uploadFileError(file: File) {
	if (!/\.(ply|spz|sog|html)$/i.test(file.name)) return "alerts.unsupportedFile";
	if (file.size > MAX_CHUNKED_UPLOAD_FILE_SIZE) return "upload.sizeError";
	if (!file.size) return "upload.emptyFile";
	return null;
}
